import React, { useEffect, useState } from 'react'
import asideModalStore from 'Stores/asideModalStore'
import FormField from 'components/UI/AsideModal/Form/FormField'
import FormLabel from 'components/UI/AsideModal/Form/FormLabel'
import { observer } from 'mobx-react'
import FileSelector from 'components/UI/FileSelector/FileSelector'
import SelectCustom from 'components/ContentBox/Global/Select/SelectCustom'
import useLocalization from 'hooks/useLocalization'
import FormFieldset from 'components/UI/AsideModal/Form/FormFieldset'

const types = [
  { id: 1, name: 'image', label: 'Image' },
  { id: 2, name: 'audio', label: 'Audio' },
  { id: 3, name: 'video', label: 'Video' },
  { id: 4, name: 'document', label: 'Document' },
]

const AddFile = () => {
  const {
    modalValues: modalValue,
    changeValue: changeValues,
    check,
  } = asideModalStore
  const [currentFormat, setCurrentFormat] = useState(null)
  const [selectedOption, setSelectedOption] = useState(null)

  const { translate } = useLocalization({
    section: 'crm',
    subsection: 'customer_card',
    dict: {
      select_file_type: 'Select the file type',
    },
  })

  useEffect(() => {
    if (typeof modalValue.type_message === 'string') {
      const foundOption = types.find(
        (type) => type.value === modalValue.type_message,
      )
      setSelectedOption(foundOption || null)
    } else {
      setSelectedOption(modalValue.type_message)
    }
  }, [modalValue.type_message, types])

  const renderFileSelector = (currentFormat) => {
    const fileSelectorProps = {
      value: modalValue.file || '',
      onChange: (val) => changeValues(val, 'file'),
      error: check('file'),
      crm: true,
    }

    switch (currentFormat) {
      case 'image':
        return (
          <FileSelector
            types={['jpeg', 'jpg', 'png', 'tif']}
            {...fileSelectorProps}
          />
        )
      case 'audio':
        return (
          <FileSelector types={['mp3']} type='audio' {...fileSelectorProps} />
        )
      case 'video':
        return (
          <FileSelector types={['mp4']} type='video' {...fileSelectorProps} />
        )
      case 'document':
        return (
          <FileSelector
            types={[
              'pdf',
              'xls',
              'xlsx',
              'doc',
              'docx',
              'pptx',
              'ppt',
              'txt',
              'zip',
              'rar',
              'zip',
              'jpeg',
              'jpg',
              'png',
              'tif',
            ]}
            type='file'
            {...fileSelectorProps}
          />
        )
      default:
        return null
    }
  }

  const handleSelectChange = (val) => {
    changeValues(val, 'type_message')
    setCurrentFormat(val.name)
    changeValues(null, 'file')
  }

  return (
    <FormFieldset>
      <FormField>
        <FormLabel>{translate.select_file_type}:</FormLabel>
        <SelectCustom
          options={types}
          onChange={handleSelectChange}
          value={selectedOption}
          placeholder={translate.select_file_type}
          error={check('type_message')}
        />
      </FormField>
      {currentFormat && (
        <FormField>
          <FormLabel>
            {currentFormat === 'audio'
              ? 'Audio'
              : currentFormat === 'video'
                ? 'Video'
                : currentFormat === 'image'
                  ? 'Image'
                  : 'Document'}{' '}
            file:
          </FormLabel>
          {renderFileSelector(currentFormat)}
        </FormField>
      )}
    </FormFieldset>
  )
}

export default observer(AddFile)
